import React from 'react';
import { createBrowserRouter, RouterProvider } from 'react-router-dom';
import { protectedRoutes } from './routes/protected-routes';
import { authRoutes } from './routes/auth-routes';
import { financeRoutes } from './routes/finance-routes';
import { benchmarkRoutes } from './routes/benchmark-routes';
import { priceBenchmarkingRoutes } from './routes/price-benchmarking-routes';
import { coordinatorRoutes } from './routes/coordinator-routes';
import { approvalRoutes } from './routes/approval-routes';
import Login from './pages/Login';
import ForgotPassword from './pages/ForgotPassword';
import ResetPassword from './pages/ResetPassword';
import PublicPaymentRequestPage from './pages/finance/PublicPaymentRequestPage';
import PublicInvestorReportPage from './pages/finance/PublicInvestorReportPage';
import NotFound from './pages/NotFound';


const router = createBrowserRouter([
  {
    path: '/login',
    element: <Login />,
  },
  {
    path: '/forgot-password',
    element: <ForgotPassword />,
  },
  {
    path: '/reset-password',
    element: <ResetPassword />,
  },
  {
    path: '/request-payment',
    element: <PublicPaymentRequestPage />,
  },
  {
    path: '/investor/:token',
    element: <PublicInvestorReportPage />,
  },
  ...benchmarkRoutes,
  ...protectedRoutes,
  ...financeRoutes,
  ...priceBenchmarkingRoutes,
  ...coordinatorRoutes,
  ...approvalRoutes,
  {
    path: '*',
    element: <NotFound />,
  },
]);

const Routes: React.FC = () => {
  return <RouterProvider router={router} />;
};

export default Routes;
